import { render, staticRenderFns } from "./InputTitle.vue?vue&type=template&id=4bfa68de&scoped=true&"
import script from "./InputTitle.vue?vue&type=script&lang=js&"
export * from "./InputTitle.vue?vue&type=script&lang=js&"
import style0 from "./InputTitle.vue?vue&type=style&index=0&id=4bfa68de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa68de",
  null
  
)

export default component.exports